import { StyleSheet } from 'react-native';

export const createStyles = (isWide: boolean) =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    scrollContent: {
      padding: isWide ? 80 : 24,
      paddingBottom: 64,
      maxWidth: 720,
      alignSelf: 'center',
      width: '100%',
    },
    backBtn: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 32,
    },
    backText: {
      fontSize: 14,
      fontWeight: '600',
    },
    postTitle: {
      fontSize: isWide ? 36 : 26,
      fontWeight: '800',
      marginBottom: 12,
      lineHeight: isWide ? 44 : 34,
    },
    postDate: {
      fontSize: 13,
      marginBottom: 16,
    },
    tagsRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
      marginBottom: 24,
    },
    tagPill: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 20,
      borderWidth: 1,
    },
    tagText: {
      fontSize: 12,
      fontWeight: '600',
    },
    divider: {
      height: 1,
      marginBottom: 32,
    },
  });
